import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Service } from "../service.class";
import { PaymentDetailModel } from "../../../shared/entities/paymentDetail.model";
import { PurchasedPackModel } from "../../../shared/entities/purchased-pack.model";

@Injectable({
	providedIn: "root",
})
export class AddonPaymentModelService {
	private server_path: string = "/v2/clients";

	constructor(private service: Service) {}

	public postPaymentDetailModel(paymentPayload?: PaymentDetailModel): Observable<PaymentDetailModel> {
		return this.service.apiPostWithoutHeaders(this.server_path + "/payments/details/final", paymentPayload);
	}

	public postPaymentDetailModelChange(paymentPayload?: PaymentDetailModel): Observable<PaymentDetailModel> {
		return this.service.apiPostWithoutHeaders(this.server_path + "/payments/change/final", paymentPayload);
	}

	public postPaymentDetailModelTrial(paymentPayload?: PaymentDetailModel): Observable<PaymentDetailModel | PurchasedPackModel> {
		return this.service.apiPostWithoutHeaders(this.server_path + "/payments/details/trial", paymentPayload);
	}

	public postPaymentDetailModelTransfer(paymentPayload?: PaymentDetailModel): Observable<PaymentDetailModel | PurchasedPackModel> {
		return this.service.apiPostWithoutHeaders(this.server_path + "/payments/details/transfer", paymentPayload);
	}
}
